/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export enum DividerTextAlignment {
  'Left' = 'left',
  'Center' = 'center',
  'Right' = 'right',
}
